import { Component } from '@angular/core';
import { PAGE_NAME } from 'app/shared/generic-grid/types/page-name.constants';

@Component({
	selector: 'app-inventory',
	templateUrl: './inventory.component.html',
	styleUrls: ['./inventory.component.scss'],
	standalone: false
})
export class InventoryComponent {
	readonly PAGE_NAME = PAGE_NAME;
}
